// werkvormen-migration.js - Updated: Steps array naar Werkwijze text field
import React, { useState } from 'react';
import { db } from '../firebase/config';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

// Uitgebreide werkvormen data - UPDATED met werkwijze in plaats van steps
const EXTENDED_WERKVORMEN = {
  vertrouwen: [
    {
      id: "vertrouwens_weersvoorspelling",
      title: "De Vertrouwens-Weersvoorspelling",
      duration: "30-45 minuten",
      participants: "4-8 personen",
      description: "Een interactieve oefening waarbij teamleden hun vertrouwensniveau uitdrukken door middel van weersymbolen. Deze werkvorm helpt om op een veilige, speelse manier kwetsbaarheden te bespreken.",
      materials: ["Whiteboard of flipchart", "Gekleurde markers", "Post-it notes", "Weersymbolen (optioneel)"],
      werkwijze: `1. Teken een groot 'weerbericht' op het whiteboard met verschillende zones (vandaag, deze week, volgende maand)

2. Leg uit dat elk teamlid hun 'vertrouwensweer' kan aangeven: ☀️ volledig vertrouwen, ⛅ wisselvallig, 🌧️ stormen verwacht

3. Laat iedereen hun huidige vertrouwensniveau plaatsen en kort toelichten waarom

4. Bespreek wat er nodig is om meer 'zonnig weer' te krijgen

5. Maak concrete afspraken voor vertrouwensverbetering`,
      tips: [
        "Houd het luchtig en speels - weersymbolen maken het minder confronterend",
        "Laat niemand verplicht delen - vrijwilligheid is essentieel",
        "Focus op de toekomst: wat kunnen we verbeteren?"
      ],
      debrief: "Welke patronen zie je? Wat zijn de grootste stormen? Welke concrete acties kunnen we ondernemen om het weer te verbeteren?",
      variations: [
        "Online variant: gebruik Miro of andere digitale whiteboards",
        "Grote teams: werk in subgroepen van 4-6 personen"
      ]
    },
    {
      id: "vertrouwens_woordweb",
      title: "Het Vertrouwens-Woordweb",
      duration: "25-35 minuten",
      participants: "3-10 personen",
      description: "Een diepgaande oefening waarbij teamleden woorden delen die hun ervaring van vertrouwen in het team beschrijven. Helpt om verschillende perspectieven op vertrouwen zichtbaar te maken.",
      materials: ["Grote vel papier of whiteboard", "Gekleurde markers", "Timer"],
      werkwijze: `1. Plaats het woord 'VERTROUWEN' in het midden van een groot vel papier

2. Geef iedereen 5 minuten om stil woorden te bedenken die hun ervaring van vertrouwen in dit team beschrijven

3. Laat elk teamlid om de beurt 2-3 woorden toevoegen rondom het centrale woord

4. Verbind gerelateerde woorden met lijnen en bespreek verbanden

5. Identificeer de sterkste en zwakste gebieden

6. Kies 3 concrete acties om vertrouwen te versterken`,
      tips: [
        "Moedig zowel positieve als negatieve woorden aan - eerlijkheid is belangrijk",
        "Vraag door bij interessante woordkeuzes",
        "Maak foto van het eindresultaat voor follow-up"
      ],
      debrief: "Welke woorden komen het meest voor? Welke woorden ontbreken? Wat kunnen we leren van de verbindingen?",
      variations: [
        "Digitale variant met online mind-mapping tools",
        "Gebruik verschillende kleuren voor verschillende aspecten van vertrouwen"
      ]
    }
  ],

  conflicten: [
    {
      id: "conflict_thermometer",
      title: "De Conflict-Thermometer",
      duration: "35-50 minuten",
      participants: "4-12 personen",
      description: "Een visuele tool om de 'temperatuur' van conflicten in het team te meten en bespreekbaar te maken. Helpt teams om constructief over meningsverschillen te praten.",
      materials: ["Whiteboard", "Gekleurde stickers of markers", "Thermometer sjabloon"],
      werkwijze: `1. Teken een grote thermometer op het whiteboard (0°C = ijskoud/vermijding tot 100°C = kokend/destructieve conflicten)

2. Laat teamleden aangeven waar verschillende soorten conflicten zich bevinden (projectbeslissingen, werkverdelingen, communicatie)

3. Bespreek de 'ideale temperatuur' voor gezonde conflicten (meestal 30-60°C)

4. Identificeer conflicten die te 'koud' (vermeden) of te 'heet' (destructief) zijn

5. Maak een actieplan om conflicten naar de gezonde zone te brengen`,
      tips: [
        "Leg uit dat 0°C (geen conflict) vaak slechter is dan 30°C (gezonde discussie)",
        "Gebruik concrete voorbeelden uit jullie team",
        "Focus op gedrag, niet op personen"
      ],
      debrief: "Waar zitten we nu? Wat is onze ideale temperatuur? Hoe kunnen we conflicten gezonder maken?",
      variations: [
        "Gebruik verschillende kleuren voor verschillende type conflicten",
        "Maak individuele thermometers en vergelijk ze"
      ]
    },
    {
      id: "conflict_woordweb",
      title: "Het Conflict-Woordweb",
      duration: "30-40 minuten",
      participants: "3-8 personen",
      description: "Verkent de verschillende dimensies van hoe het team omgaat met conflicten en meningsverschillen.",
      materials: ["Flipchart", "Markers", "Post-its"],
      werkwijze: `1. Schrijf 'CONFLICTEN' in het centrum

2. Brainstorm woorden die beschrijven hoe jullie team momenteel omgaat met conflicten

3. Categoriseer woorden in: constructief, destructief, vermijdend

4. Bespreek patronen en missing links

5. Definieer gewenste woorden voor gezonde conflicthantering`,
      tips: [
        "Accepteer alle woorden zonder oordeel",
        "Zoek naar onderliggende patronen",
        "Eindig met positieve actiewoorden"
      ],
      debrief: "Welke patronen herkennen we? Wat mist er? Hoe willen we conflicten aanpakken?",
      variations: [
        "Gebruik verschillende kleuren voor constructief vs destructief",
        "Maak persoonlijke woordwebs en vergelijk"
      ]
    }
  ],

  betrokkenheid: [
    {
      id: "betrokkenheids_kompas",
      title: "De Betrokkenheids-Kompas",
      duration: "40-55 minuten",
      participants: "4-10 personen",
      description: "Een praktische oefening om de verschillende niveaus van betrokkenheid in het team te verkennen en commitment te versterken.",
      materials: ["Groot vel papier", "Markers", "Kompas sjabloon"],
      werkwijze: `1. Teken een kompas met 4 richtingen: Noord=Volledig commitment, Oost=Actieve deelname, Zuid=Passieve medewerking, West=Weerstand

2. Laat teamleden zich positioneren bij verschillende teambeslissingen of projecten

3. Bespreek waarom mensen op verschillende plekken staan

4. Verken wat nodig is om meer naar 'Noord' te bewegen

5. Maak concrete afspraken voor verhoogde betrokkenheid`,
      tips: [
        "Gebruik concrete, actuele beslissingen uit jullie team",
        "Vraag door naar de 'waarom' achter posities",
        "Zoek naar patronen in wat betrokkenheid vergroot"
      ],
      debrief: "Waar staan we als team? Wat zorgt voor betrokkenheid vs. weerstand? Hoe kunnen we meer commitment creëren?",
      variations: [
        "Gebruik verschillende kleuren voor verschillende beslissingen",
        "Maak het persoonlijk: waar sta ik bij verschillende taken?"
      ]
    },
    {
      id: "betrokkenheids_woordweb",
      title: "Het Betrokkenheids-Woordweb",
      duration: "25-35 minuten",
      participants: "3-10 personen",
      description: "Onderzoekt de factoren die betrokkenheid en commitment in het team beïnvloeden.",
      materials: ["Whiteboard", "Gekleurde markers", "Timer"],
      werkwijze: `1. Plaats 'BETROKKENHEID' centraal

2. Verzamel woorden die betrokkenheid beschrijven, verhogen of verminderen

3. Groepeer woorden in categorieën (motivatie, communicatie, eigenaarschap, etc.)

4. Identificeer de grootste drivers en barriers

5. Prioriteer 3 acties om betrokkenheid te verhogen`,
      tips: [
        "Maak onderscheid tussen intrinsieke en extrinsieke motivatoren",
        "Betrek iedereen - ook de stillere teamleden",
        "Focus op veranderbare factoren"
      ],
      debrief: "Wat motiveert ons het meest? Welke barriers kunnen we wegnemen? Waar liggen onze grootste kansen?",
      variations: [
        "Gebruik verschillende kleuren voor drivers vs barriers",
        "Maak individuele motivatie-maps"
      ]
    }
  ],

  verantwoording: [
    {
      id: "verantwoordings_stoplicht",
      title: "Het Verantwoordings-Stoplicht",
      duration: "45-60 minuten",
      participants: "4-8 personen",
      description: "Een helder systeem om aan te geven wanneer en hoe teamleden elkaar aanspreken op gedrag en prestaties.",
      materials: ["3 gekleurde kaarten (rood, oranje, groen)", "Whiteboard", "Markers"],
      werkwijze: `1. Leg uit dat GROEN = alles loopt goed, ORANJE = aandachtspunt/zorg, ROOD = moet aangepakt worden

2. Laat het team voorbeelden geven van GROEN, ORANJE en ROOD gedrag/situaties

3. Bespreek hoe jullie momenteel omgaan met elk 'kleur' situatie

4. Definieer concrete protocols: wie spreekt aan, hoe, wanneer?

5. Oefen met rollenspel scenario's uit jullie eigen context`,
      tips: [
        "Start met GROEN voorbeelden om positief te beginnen",
        "Maak het concreet - geen vage omschrijvingen",
        "Spreek af hoe jullie dit gaan gebruiken in de praktijk"
      ],
      debrief: "Zijn we duidelijk over onze verwachtingen? Hoe kunnen we elkaar beter ondersteunen? Wat zijn onze blinde vlekken?",
      variations: [
        "Gebruik echte verkeerslichten of kleuren in de ruimte",
        "Maak persoonlijke stoplichten voor individuele development"
      ]
    },
    {
      id: "verantwoordings_woordweb",
      title: "Het Verantwoordings-Woordweb",
      duration: "30-40 minuten",
      participants: "3-10 personen",
      description: "Verkent hoe het team omgaat met wederzijdse verantwoordelijkheid en het aanspreken van elkaar.",
      materials: ["Flipchart", "Markers", "Post-its"],
      werkwijze: `1. Schrijf 'VERANTWOORDING' in het midden

2. Verzamel woorden over hoe jullie elkaar nu aanspreken

3. Voeg woorden toe over hoe jullie het zouden willen doen

4. Identificeer gaps tussen huidige en gewenste situatie

5. Formuleer concrete gedragsafspraken`,
      tips: [
        "Bespreek zowel positieve als correctieve feedback",
        "Maak het psychologisch veilig om feedback te geven en ontvangen",
        "Eindig met concrete, haalbare afspraken"
      ],
      debrief: "Wat gaat goed in ons aanspreken? Wat kunnen we verbeteren? Welke afspraken gaan we maken?",
      variations: [
        "Gebruik verschillende kleuren voor geven vs ontvangen van feedback",
        "Maak persoonlijke feedback stijlen zichtbaar"
      ]
    }
  ],

  resultaten: [
    {
      id: "resultaat_radar",
      title: "De Resultaat-Radar",
      duration: "35-50 minuten",
      participants: "4-10 personen",
      description: "Een visuele tool om te beoordelen hoe goed het team focust op collectieve resultaten versus individuele doelen.",
      materials: ["Groot vel papier", "Kompas/cirkel sjabloon", "Gekleurde markers"],
      werkwijze: `1. Teken een cirkel met 8 speerpunten: Teamdoelen, Individuele doelen, Klantresultaten, Bedrijfsresultaten, Kwaliteit, Snelheid, Innovatie, Samenwerking

2. Laat iedereen scoren (1-5) waar het team nu staat op elk punt

3. Verbind de punten om een 'radar' te maken

4. Bespreek de vorm: waar zijn we sterk/zwak?

5. Prioriteer 3 gebieden voor verbetering en maak actieplan`,
      tips: [
        "Pas de speerpunten aan naar jullie specifieke context",
        "Bespreek niet alleen de scores maar ook de reden erachter",
        "Maak het concreet met recente voorbeelden"
      ],
      debrief: "Waar ligt onze focus nu? Wat zou onze ideale radar vorm zijn? Welke trade-offs maken we?",
      variations: [
        "Maak individuele radars en vergelijk ze",
        "Gebruik verschillende kleuren voor 'nu' vs 'gewenst'"
      ]
    },
    {
      id: "team_succes_manifest",
      title: "Het Team-Succes Manifest",
      duration: "50-75 minuten",
      participants: "3-12 personen",
      description: "Het team creëert samen een manifesto dat definieert wat succesvol samenwerken voor hen betekent.",
      materials: ["Flipchart", "Markers", "Post-its", "Laptop voor finaal document"],
      werkwijze: `1. Start met individuele reflectie: 'Wat betekent teamsucces voor mij?'

2. Deel individuele ideeën en cluster gerelateerde concepten

3. Prioriteer de 5-7 belangrijkste succesfactoren

4. Formuleer voor elke factor een concrete 'Wij...' statement

5. Combineer tot een kort, krachtig team manifesto

6. Laat iedereen het manifesto ondertekenen`,
      tips: [
        "Hou het kort en krachtig - max 7 statements",
        "Gebruik actieve taal: 'Wij doen...' in plaats van 'Wij geloven...'",
        "Maak het zichtbaar in jullie werkruimte",
        "Plan reguliere check-ins tegen het manifesto"
      ],
      debrief: "Voelt dit als 'ons' manifesto? Hoe gaan we dit levend houden? Wanneer evalueren we ons hierop?",
      variations: [
        "Maak een visueel poster-formaat manifesto",
        "Creëer ook individuele commitment statements",
        "Koppel het aan jullie team-charter of waarden"
      ]
    }
  ]
};

// Migration function - UPDATED voor werkwijze support
export const migrateWerkvormen = async () => {
  try {
    console.log('🔄 Starting werkvormen migration (steps → werkwijze)...');
    
    const migrationResults = {
      success: [],
      errors: [],
      skipped: []
    };

    for (const [tredeId, werkvormen] of Object.entries(EXTENDED_WERKVORMEN)) {
      try {
        console.log(`📖 Migrating trede: ${tredeId}`);
        
        // Get current trede document
        const tredeRef = doc(db, 'tredes', tredeId);
        const tredeSnap = await getDoc(tredeRef);
        
        if (!tredeSnap.exists()) {
          console.log(`⚠ Trede ${tredeId} not found`);
          migrationResults.errors.push(`Trede ${tredeId} not found`);
          continue;
        }

        const currentData = tredeSnap.data();
        
        // Check if migration needed
        if (currentData.werkvormen && 
            currentData.werkvormen.length > 0 && 
            currentData.werkvormen[0].werkwijze) {
          console.log(`⏩ Trede ${tredeId} already has werkwijze field, skipping`);
          migrationResults.skipped.push(tredeId);
          continue;
        }

        // Update with extended werkvormen (now with werkwijze)
        await updateDoc(tredeRef, {
          werkvormen: werkvormen,
          migratedAt: new Date().toISOString(),
          migrationVersion: '3.0', // Updated version for werkwijze migration
          migrationNote: 'Migrated from steps[] array to werkwijze text field'
        });

        console.log(`✅ Successfully migrated ${tredeId} with ${werkvormen.length} werkvormen (werkwijze format)`);
        migrationResults.success.push(tredeId);
        
      } catch (error) {
        console.error(`⚠ Error migrating ${tredeId}:`, error);
        migrationResults.errors.push(`${tredeId}: ${error.message}`);
      }
    }

    console.log('🎉 Migration completed!');
    console.log('📊 Results:', migrationResults);
    
    return migrationResults;
    
  } catch (error) {
    console.error('💥 Migration failed:', error);
    throw error;
  }
};

// Helper function to convert old steps array to werkwijze text
export const convertStepsToWerkwijze = (steps) => {
  if (!steps || !Array.isArray(steps)) return '';
  
  return steps
    .filter(step => step && step.trim())
    .map((step, index) => `${index + 1}. ${step}`)
    .join('\n\n');
};

// Helper function to convert werkwijze text back to steps array (for backwards compatibility)
export const convertWerkwijzeToSteps = (werkwijze) => {
  if (!werkwijze || typeof werkwijze !== 'string') return [];
  
  // Split on numbered steps and clean up
  return werkwijze
    .split(/\n\s*\n|\d+\.\s*/)
    .filter(step => step && step.trim())
    .map(step => step.trim())
    .filter(step => step.length > 0);
};

// React component for admin panel - UPDATED
export const MigrationComponent = () => {
  const [isMigrating, setIsMigrating] = useState(false);
  const [results, setResults] = useState(null);

  const handleMigration = async () => {
    // eslint-disable-next-line no-restricted-globals
    if (!confirm('Weet je zeker dat je de werkvormen wilt migreren naar werkwijze format? Dit vervangt steps[] arrays met werkwijze text fields.')) {
      return;
    }

    setIsMigrating(true);
    try {
      const migrationResults = await migrateWerkvormen();
      setResults(migrationResults);
    } catch (error) {
      alert('⚠ Migratie mislukt: ' + error.message);
    } finally {
      setIsMigrating(false);
    }
  };

  return (
    <div style={{
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
      padding: '30px'
    }}>
      <h3 style={{ marginBottom: '20px', color: '#1f2937' }}>
        Werkvormen Migratie v3.0 - Steps → Werkwijze
      </h3>
      
      <p style={{ color: '#6b7280', marginBottom: '20px' }}>
        Upgrade werkvormen van steps[] array naar werkwijze text field voor eenvoudiger invoer van complete werkwijzen.
      </p>

      <div style={{
        background: '#f0f9ff',
        border: '1px solid #3b82f6',
        borderRadius: '8px',
        padding: '15px',
        marginBottom: '20px'
      }}>
        <h4 style={{ color: '#1e40af', margin: '0 0 10px 0' }}>Wijzigingen in deze migratie:</h4>
        <ul style={{ color: '#1e40af', margin: 0, paddingLeft: '20px' }}>
          <li>Steps array → Werkwijze text field</li>
          <li>Genummerde stappen automatisch geformatteerd</li>
          <li>Backwards compatibility behouden</li>
          <li>Admin interface aangepast voor textarea invoer</li>
        </ul>
      </div>

      <button
        onClick={handleMigration}
        disabled={isMigrating}
        style={{
          background: isMigrating ? '#9ca3af' : '#10b981',
          color: 'white',
          border: 'none',
          padding: '12px 24px',
          borderRadius: '6px',
          cursor: isMigrating ? 'not-allowed' : 'pointer',
          fontWeight: '600',
          marginBottom: '20px'
        }}
      >
        {isMigrating ? '🔄 Migreren naar Werkwijze...' : '🚀 Start Werkwijze Migratie'}
      </button>

      {results && (
        <div style={{ 
          background: '#f9fafb', 
          border: '1px solid #e5e7eb', 
          borderRadius: '6px', 
          padding: '15px' 
        }}>
          <h4>Migratie Resultaten:</h4>
          <div style={{ fontSize: '14px', marginTop: '10px' }}>
            <div style={{ color: '#059669' }}>
              ✅ Succesvol: {results.success.join(', ') || 'Geen'}
            </div>
            <div style={{ color: '#f59e0b' }}>
              ⏩ Overgeslagen: {results.skipped.join(', ') || 'Geen'}
            </div>
            <div style={{ color: '#dc2626' }}>
              ⚠ Errors: {results.errors.join(', ') || 'Geen'}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};